import { Component } from '@angular/core';
import { NavController, NavParams} from 'ionic-angular';
import { CategorySectionSinglePage } from '../category-section-single/category-section-single';

@Component({
    selector: 'page-category-section',
	templateUrl: 'category-section.html'
})
export class CategorySectionPage {

    title: string;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
        this.title = navParams.get('data');
    }

    /**
     * goToCategorySectonSingle
     */
    public goToCategorySectionSingle($item) {
        this.navCtrl.push(CategorySectionSinglePage, {
            data: $item
        });
    }


}



// WEBPACK FOOTER //
// ./src/pages/category-section/category-section.ts